import React from 'react';

export interface ColProps extends React.HTMLAttributes<HTMLDivElement> {
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
  xxl?: number;
  className?: string;
  children: React.ReactNode;
}

export const Col: React.FC<ColProps> = ({
  xs,
  sm,
  md,
  lg,
  xl,
  xxl,
  className = '',
  children,
  ...props
}) => {
  const colClasses = ['px-3 relative'];

  const getWidthClasses = (size: number, prefix: string = '') => {
    const widthMap: {[key: number]: string} = {
      1: '1/12', 2: '2/12', 3: '3/12', 4: '4/12', 5: '5/12', 6: '6/12',
      7: '7/12', 8: '8/12', 9: '9/12', 10: '10/12', 11: '11/12', 12: 'full'
    };
    const w = widthMap[size];
    return w ? `${prefix}w-${w} ${prefix}flex-none` : '';
  };

  if (!xs && !sm && !md && !lg && !xl && !xxl) {
    colClasses.push('flex-1 max-w-full');
  }

  if (xs) colClasses.push(getWidthClasses(xs));
  if (sm) colClasses.push(getWidthClasses(sm, 'sm:'));
  if (md) colClasses.push(getWidthClasses(md, 'md:'));
  if (lg) colClasses.push(getWidthClasses(lg, 'lg:'));
  if (xl) colClasses.push(getWidthClasses(xl, 'xl:'));
  if (xxl) colClasses.push(getWidthClasses(xxl, '2xl:'));

  const combinedClasses = `${colClasses.join(' ')} ${className || ''}`;

  return (
    <div className={combinedClasses} {...props}>
      {children}
    </div>
  );
};
